import {useState, useRef, useEffect} from 'react';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, Form, Label, Input, Button } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';
import useAuth from '../../hooks/useAuth';


const EditSlider = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const {id} = useParams();

  const [sliderInfo, setSliderInfo] = useState({})


  const fileInputRef = useRef();
  const [productImg, setProductImg] = useState(null)
  const [mykey, setMyKey] = useState('')


  const convertToBase64 = file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) {
        alert("please select an image")
      }else {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result)
        }
      }
      fileReader.onerror = error => {
          reject(error)
      }
    })
  }


  const addImage = async (e) => {
    const file = e.target.files[0];
    const base64Img = await convertToBase64(file);
    fileInputRef.current.value = base64Img;
    setProductImg(e.target.files[0]);
  };

  const getData = async () => {
          try {
            const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/sliders/find-slider/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            })
          
            setSliderInfo(res.data);

        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
        }
      }
    

    useEffect(() => {
      getData();
    },[id])

    // ** States
   let initialState = sliderInfo;


    const handleChange = (event) => {
        const { value, name } = event.target
        setSliderInfo(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }

    const handleUpdateClick = async (event, id) => {
        event.preventDefault();

        let sliderTitle = sliderInfo.sliderTitle;
        let sliderDesc = sliderInfo.sliderDesc;
        let sequence = sliderInfo.sliderSequence;

        const formData = new FormData();
        formData.append('sliderTitle', sliderTitle);
        formData.append('sliderDesc', sliderDesc);
        formData.append('sequence', sequence);
        formData.append('productImg', productImg);


        try {
            const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/sliders/update-slider/${id}`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + auth.accessToken
                }
            })
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            navigate('/sliders/view')


        } catch (error) {
          console.log(error)

          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
            
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      navigate('/sliders/view')
    }
 
  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Edit Slider</h5>
      </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            
          <Col sm='12' className='mb-2'>
          <Form>
            
            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Slider Title <span className='text-danger'>*</span>
              </Label>
              <Input
                id='title'
                type='text'
                className='me-1'
                name='sliderTitle'
                minLength={20}
                maxLength={90}
                required={true}
                value={sliderInfo.sliderTitle}
                onChange={handleChange}
                
              />

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Slider Description <span className='text-danger'>*</span>
              </Label>
              <Input
                id='sliderDesc'
                type='textarea'
                className='me-1'
                name='sliderDesc'
                minLength={60}
                maxLength={150}
                required={true}
                value={sliderInfo.sliderDesc}
                onChange={handleChange}
              />
            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Sequence No <span className='text-danger'>*</span>
              </Label>
              <Input
                id='sequence'
                type='number'
                className='me-1'
                name='sequence'
                min={1}
                step={1}
                required={true}
                value={sliderInfo.sliderSequence}
                onChange={handleChange}
              />
            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Image <span className='text-danger'>* (max: 200KB, w: 1920 x h: 840)</span>
              </Label>
              <Input
                id='productImg'
                type='file'
                className='me-1'
                name='productImg'
                accept='image/png, image/jpeg, image/jpg'
                required={true}
                key={mykey || ''}
                ref={fileInputRef} 
                onChange={addImage}
                // onChange={(e) => setProductImg(e.target.files[0])}
              />
            </div>
           
            {productImg  ?  <div className='mb-3 mt-3'>
             
              <div>
              <img
                 style={{width: 180}}
                 src={fileInputRef.current.value || ''} />
              </div>
            </div> : <div className='mb-3 mt-3'>
              <div>   
              {
                sliderInfo.sliderImg &&  <img style={{width: 250}} src={`${process.env.REACT_APP_API_IMAGE_URI.substring(0, process.env.REACT_APP_API_IMAGE_URI.indexOf("/api"))
               + sliderInfo.sliderImg.substring(sliderInfo.sliderImg.indexOf("/uploads"))}`} alt="slider-img"></img>
              }            
             
              </div>
           </div>}

            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={event => handleUpdateClick(event, id)}
                >
                  Update
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={event => handleReset(event)}
                  >
                    Cancel & Go to List
                  </Button>
                </div>         
              </Col>
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>
    </div>
  );
};

export default EditSlider;
